import { render, staticRenderFns } from "./SeletorDeLojasCompacto.vue?vue&type=template&id=4c614e4a&scoped=true&"
import script from "./SeletorDeLojasCompacto.vue?vue&type=script&lang=ts&"
export * from "./SeletorDeLojasCompacto.vue?vue&type=script&lang=ts&"
import style0 from "./SeletorDeLojasCompacto.vue?vue&type=style&index=0&id=4c614e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c614e4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
